module.exports = __webpack_public_path__ + "static/media/portfolio1 (47).0c2072e3.jpeg";